import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { useDispatcher } from '../../../store.decorator';
import {
    CategoryAction,
    CategoryDisplayAs,
    EventCentreHookService,
    Item,
    ItemAction,
} from '../core';

import { TranslationKeyMap } from './event-centre-dialog.i18n';
import { EventCentreDialogService } from './event-centre-dialog.service';
import { defaultState } from './event-centre-dialog.state';
import { ViewItem } from './model/view-item.model';
import { filterItems } from './state/filter-items.action';
import { toggleItemExpand } from './state/toggle-item-expand.action';
import { toggleSearch } from './state/toggle-search.action';
import { updateItems } from './state/update-items.action';

@Component({
    selector: 'cmps-event-centre-dialog',
    templateUrl: './event-centre-dialog.component.html',
    host: {
        class: 'cmps-event-centre-dialog',
    },
})
export class EventCentreDialogComponent implements OnInit, OnDestroy {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _CategoryDisplayAs = CategoryDisplayAs;

    constructor(
        private readonly _router: Router,
        /** @private */ readonly _service: EventCentreDialogService,
        private readonly _actionHookService: EventCentreHookService,
    ) {}

    ngOnInit(): void {
        useDispatcher(this._service, toggleSearch({ open: false }));
        useDispatcher(
            this._service,
            filterItems({
                opts: defaultState().filterOpts,
            }),
        );
    }

    ngOnDestroy(): void {}

    /** @private */
    _onCategoryActionClick(action: CategoryAction): void {
        this._actionHookService.categoryActionInvoked(
            this._service.state.category,
            action,
            this._service.state.filteredItems,
        );

        this._actionHookService.categoryActionInvoked2(
            this._service.state.category,
            action,
            this._service.state.filteredItems,
            this._service,
        );
    }

    /** @private */
    _onToggleExpandClick(item: Item): void {
        useDispatcher(
            this._service,
            toggleItemExpand({
                items: [item],
            }),
        );
    }

    /** @private */
    _onToggleReadClick(item: ViewItem, byExpand?: boolean): void {
        if (byExpand && (item.expanded || item.read)) {
            return;
        }
        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: { read: !item.read, delete: item.deleted },
            }),
        );
    }

    /** @private */
    _onDeleteClick(item: Item): void {
        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: { read: true, delete: true },
            }),
        );
    }

    /** @private */
    _onActionClick(item: Item, action: ItemAction): void {
        let close = false;
        if (action.url != null && action.url.trim().length > 0) {
            void this._router.navigateByUrl(action.url);
            close = true;
        } else {
            const ret1 = this._actionHookService.actionInvoked(item, action);

            const ret2 = this._actionHookService.actionInvoked2(
                item,
                action,
                this._service.state.category,
                this._service,
            );

            if (ret1 && ret2) {
                close = true;
            }
        }

        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: {
                    read: !item.read ? true : item.read,
                    delete: item.deleted,
                },
            }),
        );

        if (close) {
            this._service.close();
        }
    }
}
